import React from "react";
import "./Additional.css";

function Additional() {
    return (
        <div className="additional">
            <p>
                PHP, MySQL, React, Express.js, Git, MongoDB, Satisfactory Typing, Document and PowerPoint preparation, Computer
                Hardware maintenance, Adobe Photshop, Adobe Premiere Pro, Resource Management, Effective Communication, Leadership, Teamwork, Problem Solving, Work Enviroment Adaptability. 
            </p>
        </div>
    )
}

export default Additional;